import { ENDPOINT_NAMES, endpoints } from '../../config/endpoints';
import logError from '../../utilities/logging/log-error';
import { useData } from '@llt-frontend/react-fetch';

// Exports
// -------

export default function useStudentCourses({ userUuid, activeStudentId }) {
  const coursesEndpoint = endpoints.get(ENDPOINT_NAMES.clientCourses, {
    clientUuid: userUuid,
  });

  return useData(coursesEndpoint.path, {
    queryKey: coursesEndpoint.key,
    queryOptions: {
      enabled: Boolean(userUuid && activeStudentId),
      select(data) {
        return (
          data?.filter(({ participants }) =>
            participants.find(({ student_id }) => student_id === activeStudentId)
          ) || []
        );
      },
    },
    requestOptions: {
      onError: logError,
    },
  });
}
